import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIsMobile } from 'utils/hooks';
import Popper from 'components/Ui/Popper';
import { Button } from 'components/Ui';
import styles from './styles.scss';
import PromotionDetails from '../PromotionDetails';

const PromotionPopper = ({
  buttonLabel,
  viewCart,
  onNext,
  bottle5GCount,
  hasCartDispenser,
  goNext,
  icon,
  fullWidth,
}) => {
  const isMobile = useIsMobile();
  const [popperStatus, setPopperStatus] = useState(false);
  const ref = React.createRef();

  const RedeemButton = (
    <div ref={ref}>
      <Button
        className={styles.btn}
        text={buttonLabel}
        onClick={() => setPopperStatus(!popperStatus)}
        iconPosition="right"
        icon={icon}
        fullWidth={fullWidth}
      />
    </div>
  );
  return (
    <Popper
      className={styles.promotionPopper}
      arrowClassName={styles.popperArrow}
      button={RedeemButton}
      open={popperStatus}
      isMobile={isMobile}
    >
      <PromotionDetails
        validatePromotion
        onClickAction={() => setPopperStatus(false)}
        viewCart={viewCart}
        onNext={onNext}
        bottle5GCount={bottle5GCount}
        hasCartDispenser={hasCartDispenser}
        goNext={goNext}
      />
    </Popper>
  );
};

PromotionPopper.propTypes = {
  buttonLabel: PropTypes.string,
  viewCart: PropTypes.bool,
  onNext: PropTypes.func,
  bottle5GCount: PropTypes.number,
  hasCartDispenser: PropTypes.bool,
  goNext: PropTypes.bool,
  icon: PropTypes.any,
};

export default PromotionPopper;
